import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import { trpc } from '../../api/trpc';

import { useSelector } from '../../store/utils';

import { ControlBox } from '../../atoms/control-box';

import { NetworkHostsTable } from './network-hosts-table';
import { NetworkWan } from './network-wan';
import { NetworkOnlineStatus } from './network-online-status';

export const NetworkSettings = () => {
  const caps = useSelector((s) => s.variables.NETWORK_CAPABILITIES);
  const deviceMac = useSelector((s) => s.variables.DEVICE_MAC);

  const getData = trpc.network.get.useQuery(undefined, {
    refetchInterval: 5000,
    enabled: Boolean(caps.wanAddress) || caps.managedNetwork,
  });

  return (
    <>
      <NetworkHostsTable getData={getData} />

      {Boolean(caps.wanAddress) && (
        <NetworkWan getData={getData} canEditStatic={caps.managedNetwork} />
      )}

      {caps.wanMac && (
        <ControlBox
          title={
            <FormattedMessage
              id="settings.service.network.mac"
              defaultMessage="MAC adresa"
            />
          }
          control={<Typography sx={{ mt: 0.5 }}>{deviceMac}</Typography>}
          fullWidth
        />
      )}

      <NetworkOnlineStatus />
    </>
  );
};
